<template>
    <b-modal
        :id="modalId"
        modal-class="image-lightbox"
        body-class="image-lightbox-stage"
        hide-header
        hide-footer
        hide-backdrop
        @hidden="reset"
    >
        <button type="button" class="image-lightbox-close" aria-label="Close" @click="close">
            <i class="las la-times"></i>
        </button>
        <div class="image-lightbox-frame" @click.self="close">
            <img v-if="src" :src="src" :alt="title || 'Image'" class="image-lightbox-img">
        </div>
        <div v-if="title || caption" class="image-lightbox-caption">
            <div v-if="title" class="font-weight-bold">{{ title }}</div>
            <div v-if="caption" class="small image-lightbox-caption-muted">{{ caption }}</div>
        </div>
    </b-modal>
</template>

<script>
/**
 * Full-screen, image-first popup. Open it through a ref:
 * this.$refs.lightbox.open(url, { title, caption })
 */
export default {
    data() {
        return {
            src: null,
            title: null,
            caption: null,
        };
    },
    computed: {
        modalId() {
            return `image-lightbox-${this._uid}`;
        },
    },
    methods: {
        open(src, { title = null, caption = null } = {}) {
            if (!src) {
                return;
            }
            this.src = src;
            this.title = title;
            this.caption = caption;
            this.$bvModal.show(this.modalId);
        },
        close() {
            this.$bvModal.hide(this.modalId);
        },
        reset() {
            this.src = null;
            this.title = null;
            this.caption = null;
        },
    },
};
</script>

<style>
/* Unscoped: b-modal renders its wrapper markup outside this component */
.image-lightbox.modal {
    background: rgba(0, 0, 0, 0.92);
    padding: 0 !important;
}
.image-lightbox .modal-dialog {
    max-width: none;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    margin: 0;
}
.image-lightbox .modal-content {
    height: 100%;
    background: transparent;
    border: 0;
    border-radius: 0;
}
.image-lightbox .image-lightbox-stage {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
}
.image-lightbox-frame {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: calc(env(safe-area-inset-top) + 52px) 0 8px;
}
.image-lightbox-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    touch-action: pinch-zoom;
}
.image-lightbox-close {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 4px);
    right: calc(env(safe-area-inset-right) + 4px);
    z-index: 2;
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    font-size: 24px;
}
.image-lightbox-close:focus {
    outline: 2px solid rgba(255, 255, 255, 0.6);
}
.image-lightbox-caption {
    flex: 0 0 auto;
    color: #fff;
    text-align: center;
    padding: 8px 16px calc(env(safe-area-inset-bottom) + 12px);
}
.image-lightbox-caption-muted {
    color: rgba(255, 255, 255, 0.7);
}
</style>
